export default "/fonts/poppins-v9-latin-500.ttf?a12ca12bb6f61a241fb1de3fcae3cb8e";